import SecureLS from 'secure-ls';
import { history } from '../../history';
import { Auth } from 'aws-amplify';
import { get } from 'lodash';
import { updateLastConnection } from '../utils/misc';
import { client } from '../hoc/withApollo';
// import ability, { defineRulesFor } from './config/ability'

const ls = new SecureLS({
    encodingType: 'aes',
    isCompression: true
});

let times = 0;
let times2 = 0;

const fn = {

    clearSession (cb) {
        const callback = typeof cb === 'function' ? cb : function () { };

        ls.remove('bo_isAuthenticated');
        ls.remove('bo_accessToken');
        ls.remove('bo_idToken');
        ls.remove('bo_idTokenData');
        ls.remove('bo_refreshToken');
        ls.remove('bo_userdata');
        ls.remove('_secure__ls__metadata');
        sessionStorage.removeItem('bo_sess');
        sessionStorage.removeItem('bo_sess_ok');
        sessionStorage.removeItem('ADFS_logged');
        sessionStorage.removeItem('auth_token');
        sessionStorage.removeItem('userInfo');

        callback();
    },

    logout (cb) {
        const callback = typeof cb === 'function' ? cb : function () { };

        this.clearSession(() => {
            Auth.signOut()
                .then(data => {
                    console.log('Signout.signOut():Auth.signOut() data:', data);

                    // return history.push('/');
                    callback(data);
                })
                .catch(err => {
                    console.error('Signout.signOut():Auth.signOut() err:', err);
                    callback();
                });

            // window.location.href = '/'
        });
    },

    getToken () {
        return ls.get('bo_idToken');
    },

    isAuthenticated () {
        return ls.get('bo_isAuthenticated');
    },

    async onAuthEvent (data) {
        switch (get(data, 'payload.event')) {
        case 'signIn':
            console.log(client);
            await updateLastConnection(client);
            console.log('onAuthEvent() user signed in');
            fn.continueUserSession(get(data, 'payload.data'));
            break;
        case 'signUp':
            console.log('onAuthEvent() user signed up');
            break;
        case 'signOut':
            console.log('onAuthEvent() user signed out');
            sessionStorage.removeItem('bo_sess');
            break;
        case 'signIn_failure':
            console.log('onAuthEvent() user sign in failed');
            break;
        case 'cognitoHostedUI':
            console.log('onAuthEvent() cognito Hosted UI');
            sessionStorage.setItem('bo_sess_ok', true);
            sessionStorage.removeItem('bo_login');

            fn.continueUserSession(get(data, 'payload.data'));
            break;
        default:
            break;
        }
    },

    validateUserSession (cb) {
        const error_description = fn.getUrlParameter('error_description');
        if (!error_description) {
            // console.log('no error en url')

            this.sessionIsValid(userSession => {
                // console.log('validateUserSession', userSession)
                fn.continueUserSession(userSession);
            });
        } else {
            if (error_description.indexOf('CL_BACKOFFICE_DISABLED_USER') !== -1) {
                history.push('/');
            }
        }
    },

    sessionIsValid (cb) {
        const callback = typeof cb === 'function' ? cb : function () { };
        Auth.currentAuthenticatedUser()
            .then(currentAuthUser => {
                // console.log('currentAuthUser', currentAuthUser)

                if (!currentAuthUser) {
                    return;
                }

                const bo_sess = sessionStorage.getItem('bo_sess');
                const bo_sess_ok = sessionStorage.getItem('bo_sess_ok');

                if (bo_sess && bo_sess_ok) {
                    callback(currentAuthUser, true);
                } else {
                    if (!bo_sess) {
                        history.push('/');
                    } else {
                        // console.log('este caso no deberia ocurrir')
                    }
                }
            })
            .catch(err => {
                // console.log('err', err)
                const bo_sess = sessionStorage.getItem('bo_sess');

                if (!bo_sess) {
                    if (times2 < 3) {
                        times2++;

                        setTimeout(() => {
                            fn.sessionIsValid(cb);
                        }, 1000);
                    } else {
                        console.log('err', err);
                        history.push('/');
                    }
                } else {
                    // console.log('esperando respuesta de amplify')
                }
            });
    },

    async continueUserSession (data) {
        const session = get(data, 'signInUserSession');
        if (session) {
            const { idToken, accessToken, refreshToken } = session;

            ls.set('bo_idTokenData', idToken);
            ls.set('bo_isAuthenticated', true);
            ls.set('bo_accessToken', get(accessToken, 'jwtToken'));
            ls.set('bo_idToken', get(idToken, 'jwtToken'));
            ls.set('bo_refreshToken', get(refreshToken, 'token'));
            sessionStorage.setItem('ADFS_logged', true);
            sessionStorage.setItem('auth_token', get(accessToken, 'jwtToken'));
            sessionStorage.setItem('userInfo', JSON.stringify(get(idToken, 'payload.user', {})))
            // await fn.setRoles();
            if (get(history, 'location.pathname') === '/redirect') {
                // const role = await fn.getUserRole();

                /* if (role === 'security-access') {
                    history.push('/security')
                    return;
                } */

                history.push('/orders-monitor');
            }
        } else {
            // console.log(`no signInUserSession yet, retry number ${times}/3`);

            if (times < 3) {
                times++;

                setTimeout(() => {
                    this.continueUserSession(data);
                }, 1000);
            } else {
                // console.log('NO SIGN IN USER SESSION');
            }
        }
    },

    async getCurrentSession () {
        try {
            const data = await Auth.currentSession();
            return data;
        } catch (error) {
            console.log('error', error);
        }
    },

    async getUserRole () {
        const session = await this.getCurrentSession();
        const payload = session.idToken.payload;

        let permissions = [];
        let role = '';

        try {
            permissions = JSON.parse(payload.permissions).permissions;
            // console.log('permissions', permissions)
            role = permissions[0].id;
        } catch (err) {
            console.log('err', err);
            // message.warning('Te logueaste correctamente, pero tus roles no están correctamente asignados.', 5);
        }

        return role;
    },

    async setRoles () {
        const session = await this.getCurrentSession();

        // console.log('setRoles session', session)

        if (!session) {
            this.logout(() => {
                history.push('/');
            });
            return;
        }

        const payload = session.idToken.payload;

        let permissions = [];
        let role = '';
        let accesses = [];

        try {
            permissions = JSON.parse(payload.permissions).permissions;
            // console.log('permissions', permissions)
            accesses = permissions[0].accesses;
            role = permissions[0].id;
        } catch (err) {
            console.log('err', err);
            // message.warning('Te logueaste correctamente, pero tus roles no están correctamente asignados.', 5);

            this.logout(() => {
                history.push('/');
            });
            return;
        }

        if (role === 'not-authorized') {
            // message.warning('Usuario no autorizado.', 5);

            this.logout(() => {
                history.push('/');
            });
            return;
        }

        // console.log('accesses', accesses)

        // console.log('permissions', permissions[0])
        const userdata = JSON.parse(payload.user);
        const name = payload.name;
        const family_name = payload.family_name;
        const email = payload.email;

        ls.set('bo_userdata', userdata);

        const user = {
            role,
            user: {
                id: email,
                name: `${name} ${family_name}`
            },
            rules: accesses
        };

        // console.log('role', role);
        // console.log('update rules user', user)
        // ability.update(defineRulesFor(user))
    },

    getUrlParameter (name) {
        // eslint-disable-next-line
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(history.location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    getEnvironment () {
        console.log('getEnvironment');
        const APP_ENV = process.env.REACT_APP_APP_ENV;
        const host = window.location.hostname;
        // console.log('APP_ENV', APP_ENV)
        // console.log('host', host)

        const env = host === 'localhost' ? 'local' : (APP_ENV === 'PROD' ? 'prod' : 'qa');
        return env;
    }

};

window.fn = fn;

export default fn;
